import { AntdProTable, ButtonPrimeReact } from "@finanedi.es/storybook"
import { useGrupoImpuesto } from "api/GrupoImpuesto.hook"
import { useImpuestoEmpresaById } from "api/ImpuestoEmpresa.hook"
import { getImpuestoEmpresa } from "api/ImpuestoEmpresa.service"
import { antdProTablePaginationHandler } from "handlers/antdProTablePaginationHandler"
import { useDispatch } from "hooks/useDispatch"
import { useFilterMenu } from "hooks/useFilterMenu"
import { useCallback, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import TaxesModal from "./Modal/TaxesModal"
import { TAXES_COLUMNS } from "./constants/taxesColumns"

const Taxes = () => {
  const { t } = useTranslation()
  const { grupoImpuesto } = useGrupoImpuesto()
  const [show, setShow] = useState()
  const [edit, setEdit] = useState()
  const {
    impuestoEmpresaById,
    impuestoEmpresaByIdRemoval,
    impuestoEmpresaByIdIsLoading,
    // @ts-expect-error TS(2339): Property 'id' does not exist on type 'never'.
  } = useImpuestoEmpresaById(edit?.id)
  const dispatch = useDispatch()
  const paginationSkipCount = useRef(0)
  const fetchImpuestoEmpresa = useCallback(
    () => (queryParams: $TSMigrationFixMe) =>
      getImpuestoEmpresa({
        SortingCriteria: "CreationTime ASC",
        ...queryParams,
      }),
    []
  )
  const { items, isLoading, totalCount, fetchTableData } = useFilterMenu({
    serviceCall: fetchImpuestoEmpresa,
  })
  const handleConfirmEdit = () => {
    fetchTableData()
    // @ts-expect-error TS(2345): Argument of type 'false' is not assignable to para...
    setShow(false)
    // @ts-expect-error TS(2345): Argument of type 'null' is not assignable to param...
    setEdit(null)
    impuestoEmpresaByIdRemoval()
  }

  const handleOnRowClick = (rowData: $TSMigrationFixMe) => {
    setEdit(rowData)
    // @ts-expect-error TS(2345): Argument of type 'true' is not assignable to param...
    setShow(true)
  }

  return (
    <section className='tw-w-full'>
      <header className='tw-bg-white !tw-px-8 tw-flex tw-flex-row tw-justify-between tw-items-center tw-pb-4 tw-pt-6 tw-border-b tw-rounded-t-xl'>
        <p className='tw-whitespace-nowrap tw-text-2xl tw-text-text tw-my-auto'>
          {t("impuestos.title")}
        </p>
        <ButtonPrimeReact
          // @ts-expect-error TS(2345): Argument of type 'true' is not assignable to param...
          onClick={() => setShow(true)}
          className='!tw-bg-secondary !tw-border-none hover:!tw-bg-secondary-over tw-h-10'
        >
          {t("impuestos.addTax")}
        </ButtonPrimeReact>
      </header>
      <div>
        <AntdProTable
          showHeader={!!items?.length}
          data-testid='tabla-user-taxes'
          id='tabla-user-taxes'
          className='tw-mb-6'
          rowKey='id'
          columns={TAXES_COLUMNS({ t, refetchTableData: fetchTableData })}
          rowSelection={false}
          onRow={(rowData: $TSMigrationFixMe) => ({
            onClick: (e: $TSMigrationFixMe) => {
              e.stopPropagation()
              const isSwitchElement = e.target?.className?.includes("tw-peer")
              !isSwitchElement && handleOnRowClick(rowData)
            },

            className: "tw-cursor-pointer",
          })}
          items={items}
          loading={isLoading}
          totalCount={totalCount}
          pagination={antdProTablePaginationHandler({
            totalCount,
            t,
            paginationSkipCount,
            defaultPageSize: 100,
          })}
        />
      </div>

      <TaxesModal
        // @ts-expect-error TS(2322): Type '{ show: undefined; setShow: Dispatch<SetStat...
        show={show}
        setShow={setShow}
        taxes={grupoImpuesto}
        editing={!!edit}
        setEdit={setEdit}
        // @ts-expect-error TS(2339): Property 'id' does not exist on type 'never'.
        isLoading={edit?.id && impuestoEmpresaByIdIsLoading}
        edit={impuestoEmpresaById || {}}
        dispatch={dispatch}
        refetchTableData={fetchTableData}
        confirmEdit={handleConfirmEdit}
        t={t}
      />
    </section>
  )
}

export default Taxes
